import { getTranslation as t } from '../lib/i18n';

export function getMessageFromResponse(payload, defaultMessage = t('请稍后再试')) {
	try {
		return payload.error.message;
	} catch (e) {
		console.log(e);
	}

	return defaultMessage;
}

export function catchErrorMessageForSocket(error, ...callbacks) {
	const errorMessage = getMessageFromResponse(error, t('请稍后再试'));

	return callbacks.map(callback => callback(error, errorMessage));
}

// 後端錯誤事件會原樣回傳 request 的 messageId（server/cs.js 的錯誤 middleware），
// 用這組 encode/decode 把 entityId（如 conversationReplyId）夾帶進 messageId，
// 讓 error receiver 能判斷「是哪一筆」失敗。集中成共用函式，emitter/receiver 兩邊的格式才不會各自漂移。
const MESSAGE_ID_ENTITY_ID_SEPARATOR = ':';

export function generateMessageIdWithEntityId(topic, entityId) {
	return `${topic}${MESSAGE_ID_ENTITY_ID_SEPARATOR}${entityId}`;
}

export function getEntityIdFromMessageId(messageId = '') {
	const [, entityId] = messageId.split(MESSAGE_ID_ENTITY_ID_SEPARATOR);

	return entityId;
}
